import { api } from 'data/api/api'

import { ComplaintResp } from '../types/complaint'

export const getComplaint = (id: string) => api.get<ComplaintResp>(`/complaints/${id}`)
